import { Stack } from '@chakra-ui/layout';
import { Skeleton } from '@chakra-ui/skeleton';

const AssetsLoadingSkeleton = () => {
  const skeletonProps = {
    height: '22px',
    startColor: 'gray.500',
    endcolor: 'gray.600',
  };
  return (
    <Stack p={6} borderRadius='xl' bg='gray.700' spacing={4}>
      <Skeleton {...skeletonProps} />
      <Skeleton {...skeletonProps} />
      <Skeleton {...skeletonProps} />
      <Skeleton {...skeletonProps} />
    </Stack>
  );
};

export default AssetsLoadingSkeleton;
